// extracted by mini-css-extract-plugin
export default {"UserFormRoot":"UserFormRoot---u4bNK","UserFormEditIcon":"UserFormEditIcon---aDCe3","nameContainer":"nameContainer---hqbkS","pronouns":"pronouns---j1QEu"};